@if (useColorGroup && selectableGroups.length > 1) {
<div class="customizer-colors-container">
	@for (group of selectableGroups; track $index) {
	<button class="btn-outline round extra-padding" [ngClass]="{'toggled': selectedColorGroup && group?.Id === selectedColorGroup.Id}" (click)="setColorGroup(group)">
		{{$safeNavigationMigration(group?.Description) | dataTranslate | translate}}
	</button>
	}
</div>
}

@if (selectedColorGroup || !useColorGroup) {
<div class="colors-list" id="colorlist" (scrollChange)="updatePosition($event)">
	@for (color of selectableColors; track $index) {
	<customizer-color-item
		class="customizer-item"
		[ngClass]="{'is-selected': color?.ColorUuid === selected?.ColorUuid}"
		[matchableColors]="matchableColors"
		[showNoneChoiceOption]="showNoneChoiceOption"
		[editMode]="editMode"
		[attr.data-id]="color?.Uuid"
		[attr.data-guid]="color?.ColorUuid"
		[selected]="selected && color?.ColorUuid === selected.ColorUuid"
		[matchColor]="matchColor"
		[color]="color"
		[extendedInformation]="extendedInformation"
		[extendedInformationTable]="extendedInformationTable"
		[specialColorText]="specialColorText"
		[imageClass]="imageClass"
		[noneChoiceTranslation]="translation"
		[useColorGroup]="useColorGroup"
		[matchableMisc]="matchableMisc"
		[variantOrModelIsNew]="variantOrModelIsNew"
		(clickedChange)="setSelected(color)"
		(matchColorClicked)="matchColors($event)"
		(matchMiscClicked)="miscMatch($event)"
	>
	</customizer-color-item>
	}
</div>
}
